<template>
  <div
    ref="kt_modal_pedido_item_det_pesagens_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_pedido_item_det_pesagens_consultar"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="card">
            <div class="card-header">
              <div class="card-title d-flex align-items-center">
                <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                  <inline-svg src="media/icons/duotune/ecommerce/ecm002.svg" />
                </span>
                <h3 class="fw-bold m-0 text-gray-800">
                  {{ this.labelDescricao }}
                </h3>
              </div>
              <div
                class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                data-bs-dismiss="modal"
                @click="this.$emit('exibirModalPedidoItemDetPesagens', false)"
              >
                <span class="svg-icon svg-icon-1 svg-icon lh-0">
                  <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                </span>
              </div>
            </div>
            <div class="card-body p-0">
              <div
                v-if="this.errosValidacaoGeral.length"
                class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
              >
                <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                  <inline-svg src="media/icons/duotune/general/gen044.svg" />
                </span>
                <div class="d-flex flex-stack flex-grow-1">
                  <div class="fw-bold">
                    <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                    <div class="fs-6 text-gray-600">
                      <ul>
                        <li
                          v-for="value in this.errosValidacaoGeral"
                          :key="value"
                        >
                          {{ value }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-header border-0 pt-5">
                <div class="card-title">
                  <div class="d-flex align-items-center position-relative my-1">
                    <span class="svg-icon svg-icon-1 position-absolute ms-6">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                    <input
                      type="text"
                      id="txtPesquisarPedidoItemDetPesagens"
                      v-model="tableData.search"
                      @input="onSearch($event.target.value)"
                      class="form-control form-control-solid w-250px ps-15"
                      placeholder="Pesquisar cadastro"
                    />
                  </div>
                </div>
                <div class="card-toolbar">
                  <div
                    v-if="checkedPedidoItemDetPesagens.length === 0"
                    class="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <button
                      v-if="this.adicionar"
                      @click="adicionarPedidoItemDetPesagem()"
                      class="btn btn-sm btn-primary"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg" /></span
                      >Adicionar
                    </button>
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-end align-items-center"
                    data-kt-customer-table-toolbar="selected"
                  >
                    <div class="fw-bolder me-5">
                      <span class="me-2">{{
                        checkedPedidoItemDetPesagens.length
                      }}</span
                      >Selecionado(s)
                    </div>
                    <button
                      v-if="this.excluir"
                      type="button"
                      class="btn btn-sm btn-danger"
                      @click="deleteSelecionados()"
                    >
                      Excluír Selecionado(s)
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <Datatable
                  ref="table"
                  :table-header="tableHeader"
                  :table-data="tableData"
                  :table-pagination="tablePagination"
                  :page-sizes="pageSizes"
                  :enable-items-per-page-dropdown="true"
                  :hide-on-single-page="false"
                  empty-table-text="Nenhum cadastro encontrado"
                  @checked-rows="checkedPedidoItemDetPesagens = $event"
                >
                  <template
                    v-slot:cell-checkbox="{ row: pedidoItemDetPesagem }"
                  >
                    <div
                      class="form-check form-check-sm form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="pedidoItemDetPesagem.id"
                        v-model="checkedPedidoItemDetPesagens"
                      />
                    </div>
                  </template>
                  <template v-slot:cell-id="{ row: pedidoItemDetPesagem }">
                    {{ pedidoItemDetPesagem.id }}
                  </template>
                  <template
                    v-slot:cell-descricao="{ row: pedidoItemDetPesagem }"
                  >
                    {{ pedidoItemDetPesagem.descricao }}
                  </template>
                  <template v-slot:cell-acoes="{ row: pedidoItemDetPesagem }">
                    <div>
                      <button
                        class="btn btn-sm btn-light btn-active-light-primary"
                        data-kt-menu-trigger="click"
                        data-kt-menu-placement="bottom-end"
                        data-kt-menu-flip="top-end"
                      >
                        Ações
                        <span class="svg-icon svg-icon-5 m-0">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr072.svg"
                          />
                        </span>
                      </button>
                      <div
                        v-if="this.editar || this.excluir"
                        class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                        data-kt-menu="true"
                      >
                        <div v-if="this.editar" class="menu-item px-3">
                          <a
                            @click="
                              editarPedidoItemDetPesagem(pedidoItemDetPesagem)
                            "
                            class="menu-link px-3"
                            >Editar</a
                          >
                        </div>
                        <div v-if="this.excluir" class="menu-item px-3">
                          <a
                            @click="removerRegistro(pedidoItemDetPesagem.id)"
                            class="menu-link px-3"
                            >Excluír</a
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </Datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="exibirEditarPedidoItemDetPesagem"
    id="kt_modal_pedido_item_det_pesagem_editar"
    ref="kt_modal_pedido_item_det_pesagem_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.pedidoItemDetPesagem.id === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar {{ this.labelDescricao }}
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar {{ this.labelDescricao }}
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.modalEditarPedidoItemDetPesagem(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div class="col-md-3 fv-row mb-4">
              <label class="form-label">Código</label>
              <input
                id="txtCodigo"
                type="text"
                class="form-control mb-2"
                v-model="pedidoItemDetPesagem.id"
                disabled
              />
            </div>
            <div class="col-md-9 fv-row mb-4">
              <label class="required form-label">Descrição</label>
              <input
                id="txtDescricaoPedidoItemDetPesagem"
                type="text"
                class="form-control mb-2"
                placeholder="Descrição do cadastro"
                maxlength="200"
                v-model="pedidoItemDetPesagem.descricao"
                @keydown.stop.prevent.enter="
                  nextFocus(`btnConfirmarPedidoItemDetPesagem`)
                "
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["descricao"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.modalEditarPedidoItemDetPesagem(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            id="btnConfirmarPedidoItemDetPesagem"
            @click="confirmarPedidoItemDetPesagem()"
            v-bind:data-kt-indicator="
              this.loadingPedidoItemDetPesagem ? 'on' : 'off'
            "
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span
              class="svg-icon svg-icon-1"
              v-if="!this.loadingPedidoItemDetPesagem"
            >
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["exibirModalPedidoItemDetPesagens", "confirmarPedidoItemDetPesagem"],
  components: {
    Datatable,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(descricao, '" + pesquisa + "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async deleteSelecionados() {
      await this.$swal.showQuestionAlert(
        "Deseja remover os registros selecionados?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            for (var i = 0; i < this.checkedPedidoItemDetPesagens.length; i++) {
              await this.excluirPedidoItemDetPesagem(
                this.checkedPedidoItemDetPesagens[i]
              );
            }
            if (this.excluiuCadastro === true) {
              toast.success("Cadastros excluídos com sucesso!", {
                timeout: 3000,
              });
              this.$emit("confirmarPedidoItemDetPesagem");
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async removerRegistro(id) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            await this.excluirPedidoItemDetPesagem(id);
            if (this.excluiuCadastro === true) {
              toast.success("Cadastro excluído com sucesso!", {
                timeout: 3000,
              });
              this.$emit("confirmarPedidoItemDetPesagem");
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async excluirPedidoItemDetPesagem(id) {
      try {
        await this.$store.dispatch(
          "pedidoItemDetPesagem/deletePedidoItemDetPesagem",
          id
        );
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    modalEditarPedidoItemDetPesagem(exibir) {
      this.exibirEditarPedidoItemDetPesagem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_item_det_pesagem_editar",
          /*open*/ () => {
            this.$utils.requestFocus("txtDescricaoPedidoItemDetPesagem");
          },
          /*close*/ () => {
            this.modalEditarPedidoItemDetPesagem(false);
          }
        );
      }
    },
    adicionarPedidoItemDetPesagem() {
      this.pedidoItemDetPesagem = {
        id: 0,
        descricao: "",
      };
      this.modalEditarPedidoItemDetPesagem(true);
    },
    editarPedidoItemDetPesagem(pedidoItemDetPesagem) {
      this.pedidoItemDetPesagem = pedidoItemDetPesagem;
      this.modalEditarPedidoItemDetPesagem(true);
    },
    async confirmarPedidoItemDetPesagem() {
      this.errosValidacao = [];
      this.loadingPedidoItemDetPesagem = true;
      if (this.pedidoItemDetPesagem.id === 0) {
        try {
          var ret = await this.$store.dispatch(
            "pedidoItemDetPesagem/postPedidoItemDetPesagem",
            this.pedidoItemDetPesagem
          );
          if (ret.Success === true) {
            toast.success("Cadastro registrado com sucesso!", {
              timeout: 3000,
            });
            this.$emit("confirmarPedidoItemDetPesagem");
            hideModalId("kt_modal_pedido_item_det_pesagem_editar");
            this.modalEditarPedidoItemDetPesagem(false);
            this.$refs.table.load();
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "pedidoItemDetPesagem/putPedidoItemDetPesagem",
            this.pedidoItemDetPesagem
          );
          if (retPut.Success === true) {
            toast.success("Cadastro alterado com sucesso!", { timeout: 3000 });
            this.$emit("confirmarPedidoItemDetPesagem");
            hideModalId("kt_modal_pedido_item_det_pesagem_editar");
            this.modalEditarPedidoItemDetPesagem(false);
            this.$refs.table.load();
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      }
      this.loadingPedidoItemDetPesagem = false;
    },
    async carregarLabelDescricao() {
      try {
        var ret = await this.$store.dispatch(
          "labelDescricao/getLabelDescricaoOData",
          "?$select=descricao&$filter=campo eq '79a00056-12d0-4c8f-b3f4-d95d183ff7f6'"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.labelDescricao = ret.value[0].descricao;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.PedidoItemDetPesagem.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.PedidoItemDetPesagem.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.PedidoItemDetPesagem.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.carregarLabelDescricao();
    await this.verificarRestricoes();
    this.$utils.requestFocus("txtPesquisarPedidoItemDetPesagens");
  },
  data() {
    return {
      exibirEditarPedidoItemDetPesagem: false,
      labelDescricao: "",
      loadingPedidoItemDetPesagem: false,
      pedidoItemDetPesagem: {
        id: 0,
        descricao: "",
      },
      adicionar: false,
      editar: false,
      excluir: false,
      checkedPedidoItemDetPesagens: [],
      errosValidacaoGeral: [],
      errosValidacao: {},
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "pedidoItemDetPesagem/getPedidoItemDetPesagemOData",
        selectOData: "?$select=id,descricao",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
